export const contato = {
  email_it: "OL-IT-Precatorios@btgpactual.com",
  email_support: "contato@precatoriosbrasil.com",
  email: "contato@precatoriosbrasil.com",
  telefone3: "(11) 3383-6179",
  whatsappFormatado: "(11) 4003-9058",
  whastapp: "1140039058"
};



// WEBPACK FOOTER //
// ./src/util/constants.ts